import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import PlatformPortMappingViewForm from './PlatformPortMappingViewForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import PlatformPortMappingKeys from 'src/constants/locale/key/PlatformPortMapping'

const { CngTabs } = components


function ViewPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.PLATFORM_PORT_MAPPING])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let platformPortMapping = translate(
      Namespace.PLATFORM_PORT_MAPPING,
      PlatformPortMappingKeys.TITLE
    )

    return {
      platformPortMapping
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <PlatformPortMappingViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
                //do nothing
              }}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.platformPortMapping,
              tabContent: (
                <PlatformPortMappingViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage